import React from 'react';
import { AdminProfileContainer } from '@/modules/AdminProfile';

const Profile = (): JSX.Element => <AdminProfileContainer />;

export default Profile;
